import BranchCrud from './BranchCrud'
export {BranchCrud}
export default BranchCrud
